
import React, {useContext, useEffect, useState} from 'react';
import './MainMenu.css';
import Header from '../../components/Headers/Header.jsx';
import MainMenuCard from './components/MainMenuCard';
import ChatApp from '../../components/ChatApp/ChatApp.jsx'
import { Context } from '../../index.js';
import FillProfileForm from '../Home/components/Home/AuthForm/FillProfileForm/FillProfileForm.jsx'

const MainMenu = () => {

    const {user} = useContext(Context)

    const [displayProfileFill, setDisplayProfileFill] = useState(Context)

    useEffect(() => {
        setDisplayProfileFill(user.displayProfileFill)
    }, [user.displayProfileFill])

    return (
        <>
            <div className="MainMenu h-100">
                <Header />
                <div className="mainMenu mt">
                    <div className="mainMenu__list">
                        <MainMenuCard />
                    </div>
                </div>
                <ChatApp/>
                {displayProfileFill && <FillProfileForm onClose={setDisplayProfileFill(false)} />}
            </div>
        </>
    );
};

export default MainMenu;
